exports.userHaveRoles = roles => {
  const userLogin = JSON.parse(window.localStorage.getItem('user_data'));
  const userRoles = userLogin.roles
  
  
  if(roles.map(role => userRoles.some(user_role => user_role.name === role)).includes(true)){
    return true
  }else{
    return false
  }
}

exports.generateUrlQueryString = payload => {
  let str = ''
  Object.keys(payload).map((key) => {
    if (payload[key] && Array.isArray(payload[key]) && payload[key].length > 0) {
      payload[key].map((n, index) => (str += `${key}[${index}]=${n}&`));
    } else {
      str += `${key}=${payload[key]}&`;
    }
  });
  return str;
}